import src from "IMAGE";
export default { src, width: 647, height: 745, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAPElEQVR42sXJOwqAMBRE0ex/oVZ+ICoBzfOopSlsc5uBOSnPjAN54jx8SmVnXSgbURuMoD7nu64G/dQDb30U3lrOs9mTAAAAAElFTkSuQmCC"};
